import { createContext } from "react";
export const ThemeContext = createContext({});
export const InfoContext = createContext({}) ;
export const DesignContext = createContext({});